import request from '../request'

export default {
  getPersonalMedioTipo: function () {
    return request.get('personal_medio_tipo')
  }
}
